import React from 'react';
import styles from './Footer.module.css';

const socialLinks = [
  { href: '#', alt: 'facebook', icon: '/icon-facebook.svg' },
  { href: '#', alt: 'Instagram', icon: '/icon-whatsapp.svg' },
  { href: '#', alt: 'Contato', icon: '/icon-instagram.svg' },
];

const Footer = () => (
  <footer className={styles.footer}>
    {socialLinks.map((item, idx) => (
      <a key={idx} href={item.href} target="_blank" rel="noopener noreferrer">
        <img src={item.icon} alt={item.alt} className={styles["social-icon"]} />
      </a>
    ))}
  </footer>
);

export default Footer; 